import { render, staticRenderFns } from "./dashboardWanchengdu.vue?vue&type=template&id=4ad648e0&scoped=true"
import script from "./dashboardWanchengdu.vue?vue&type=script&lang=js"
export * from "./dashboardWanchengdu.vue?vue&type=script&lang=js"
import style0 from "./dashboardWanchengdu.vue?vue&type=style&index=0&id=4ad648e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad648e0",
  null
  
)

export default component.exports